import script from "./TheHeaderComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheHeaderComponent.vue?vue&type=script&lang=ts&setup=true"

import "./TheHeaderComponent.vue?vue&type=style&index=0&id=677ccf23&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-677ccf23"]])

export default __exports__